import React, {FC} from 'react';
import styled from 'styled-components';

import {ActivationsListProps} from './ActivationsList';

const ItemWrapper = styled.div<{isSelected?: boolean}>`
    & > span > div {
        border-bottom: 1px solid #0b0b0b;
        background-color: ${p =>
            p.isSelected
                ? p.theme.muiTheme.palette.background.paper
                : p.theme.muiTheme.palette.background.overlays};
    }
`;

interface ActivationItemWrapperProps extends Omit<ActivationsListProps, 'activations'> {
    index: number;
    children: React.ReactChild;
}

const ActivationItemWrapper: FC<ActivationItemWrapperProps> = ({
    index,
    children,
    activeIndex,
    handleIndexChange
}: ActivationItemWrapperProps) => {
    const isSelected = activeIndex === index;
    const handleEnter = () => handleIndexChange(index);
    const handleLeave = () => handleIndexChange();

    return (
        <ItemWrapper
            isSelected={isSelected}
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
            onClick={handleEnter}>
            {children}
        </ItemWrapper>
    );
};

export default ActivationItemWrapper;
